<template>
  <section class="EmployeesDeactivateModal">
    <MuiCardAlert
      v-if="STATUS.DEACTIVATE_IN"
      full-width
      type="info"
    >
      {{ isActivation ? 'Activating Employee:' : 'Please wait, Deactivating Employee:' }}

      <div class="color-ink-light mt-2">
        {{ employeeName }}
      </div>
    </MuiCardAlert>

    <MuiCardAlert
      v-if="STATUS.DEACTIVATE_SUCESS"
      full-width
      type="success"
    >
      {{ `Successful ${isActivation ? 'Activation' : 'Deactivation'} of the Employee:` }}
      <div class="color-ink-light mt-2">
        {{ employeeName }}
      </div>
    </MuiCardAlert>

    <MuiCardAlert
      v-if="STATUS.DEACTIVATE_ERROR"
      full-width
      type="danger"
    >
      {{ `We are sorry, there was a problem with the ${isActivation ? 'Activation' : 'Deactivation'} of the Employee:` }}
      <div class="color-ink-light mt-2">
        {{ employeeName }}
      </div>
    </MuiCardAlert>
    <p v-if="STATUS.IDLE">
      {{ `Are you sure you want to ${isActivation ? 'activate' : 'deactivate'} the user?` }}
    </p>
  </section>
</template>

<script>

import { mapState } from 'vuex';

import { MuiCardAlert } from '@ubeeqo/motion-ui';
import VIEW_MODEL from '@/store/modules/VIEW_MODEL';

export default {
  name: 'EmployeesDeactivateModalComponent',
  components: {
    MuiCardAlert,
  },
  props: {
    isActivation: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapState(VIEW_MODEL.companyAdmin.employees, {
      employeeName: state => state.employeeName,
      STATUS: state => state.STATUS,
    }),
  },
};
</script>
